import {
  AntragDruck,
  Dokument as BffDokument,
  DokumentenErstellungRequestModel,
  SparteDruckdaten,
  SpartenType,
  UriDruckdaten,
  VersichertePersonDruck,
  WeweDruckDaten,
} from '@ps20/bff-models';
import { getTarifbereich } from '@ps20-frontend/frontend-models';
import { IAppState } from '../../localStore';
import {
  addCheckoutDataToSparteDruckdaten,
  mapVermittler,
  mapVersicherungsnehmer,
} from './common-druckdaten.mapper';

export function mapEinwilligung(
  state: IAppState,
  sparteDruckdaten: Array<SparteDruckdaten>,
): DokumentenErstellungRequestModel<WeweDruckDaten> {
  const data = {
    dokumentDruckdaten: {
      dokument: BffDokument.WEWE,
    },
    antraege: mapAntraegeMitBeibehaltung(sparteDruckdaten),
    sammelantragsnummer: state.sammelantragsnummer,
    vermittler: mapVermittler(state),
    sparteDruckdaten: spartenDruckDatenForEinwilligung(sparteDruckdaten, state),
    versicherungsnehmer: mapVersicherungsnehmer(state),
    tarifbereich: getTarifbereich(state.versicherungsnehmer),
  };
  return data;
}

export function getAllVersichertePersonenForEinwilligung(
  sparteDruckdaten: Array<SparteDruckdaten>,
): Array<VersichertePersonDruck> {
  const druckDatenArray: Array<SparteDruckdaten> = sparteDruckdaten.filter(
    sparteDruckdata => sparteDruckdata.spartenType === SpartenType.UNFALL,
  );
  if (!druckDatenArray || druckDatenArray.length === 0) {
    return;
  }
  return druckDatenArray.map(druckDaten => (druckDaten as UriDruckdaten).versichertePerson);
}

function spartenDruckDatenForEinwilligung(
  sparteDruckdaten: Array<SparteDruckdaten>,
  state: IAppState,
): SparteDruckdaten {
  const druckDaten = sparteDruckdaten.find(
    sparteDruckdata => sparteDruckdata.spartenType === SpartenType.UNFALL,
  );
  if (!druckDaten) {
    return;
  }
  return addCheckoutDataToSparteDruckdaten(state, druckDaten);
}

function mapAntraegeMitBeibehaltung(sparteDruckdaten: Array<SparteDruckdaten>): AntragDruck[] {
  return sparteDruckdaten.map(sparteDruckdata => ({
    antragsnummer: sparteDruckdata.antragsnummer,
    longText: sparteDruckdata.longText,
    shortText: sparteDruckdata.shortText,
    spartenType: sparteDruckdata.spartenType,
    beibehalten: sparteDruckdata.beibehalten,
  }));
}
